import { MainInner, MainSection } from "@/styles/global";
import { H1, H3, Body } from "@/styles/typography";
import { GatsbyImage } from "gatsby-plugin-image";
import styled from "styled-components";

const BlogSection = styled(MainSection)`
  margin-top: 0;
`;

const BlogInner = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 802px;
`;

const Title = styled(H1)`
  color: ${({ theme }) => theme.colors.textBlack};
  font-size: 50px;
  margin-bottom: 8px;
  font-family: "Wallop TRIAL", sans-serif;
  line-height: 110%;
`;

const InfoWrapper = styled.div`
  margin-bottom: 48px;
`;

const Date = styled(Body)`
  font-family: "Wallop TRIAL", sans-serif;
  font-size: 13px;
  font-style: normal;
  font-weight: 500;
  line-height: 140%; /* 18.2px */
  letter-spacing: 0.13px;
  text-transform: uppercase;
`;

const Image = styled(GatsbyImage)`
  width: 100%;
  img {
    border-radius: 20px;
  }
`;

const ContentWrapper = styled.div<{ $bgColor: string }>`
  background-color: ${({ $bgColor, theme }) => theme.colors[$bgColor]};
  ${({ $bgColor }) =>
    $bgColor !== "white"
      ? `margin: 48px 0;
  padding-block: 48px;
  `
      : `margin-top: 48px;`}
`;

const RelatedBlog = styled.div`
  background-color: ${({ theme }) => theme.colors.creme};
`;

const RelatedBlogInner = styled(MainInner)`
  padding: 88px 0 88px 88px;
`;

const RelatedTitle = styled(H3)`
  margin-bottom: 32px;
  font-family: "Wallop TRIAL", sans-serif;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 130%; /* 26px */
  color: ${({ theme }) => theme.colors.textBlack};
`;

const S = {
  BlogSection,
  BlogInner,
  Title,
  InfoWrapper,
  Date,
  Image,
  ContentWrapper,
  RelatedBlog,
  RelatedBlogInner,
  RelatedTitle,
};

export default S;
